// Import JS Modules
const pricingSlider = require('./modules/pricingSlider')
const animations = require('./modules/animations')
const loadMore = require('./modules/loadMore')
const sourceCookie = require('./modules/sourceCookie')
const scripts = require('./modules/scripts')

document.addEventListener('DOMContentLoaded', pricingSlider.init)
document.addEventListener('DOMContentLoaded', animations.init)
document.addEventListener('DOMContentLoaded', loadMore.init)
document.addEventListener('DOMContentLoaded', scripts.init)
document.addEventListener('DOMContentLoaded', sourceCookie.init)

